import ReactMarkdown from "react-markdown";
import { HTMLLevels, Heading } from "../Heading";
import { Text } from "../Text";

function Richtext({ content, className }: { content: string; className?: string }) {
  return (
    <ReactMarkdown
      children={content}
      components={{
        h2: (props) => (
          <Heading
            {...props}
            className="text-2xl mt-20 mb-2 text-center antialiased font-bold"
            level={HTMLLevels.h2}
          />
        ),
        h3: (props) => (
          <Heading
            {...props}
            className="text-xl mt-20 mb-2 text-center antialiased font-bold"
            level={HTMLLevels.h3}
          />
        ),
        p: (props) => (
          <Text
            {...props}
            className={`text-neutral-500 my-5 antialiased whitespace-pre-wrap${className ? ` ${className}` : ""}`}
          />
        ),
        li: (props) => (
          // @ts-expect-error ordered is not a valid prop for li
          <li {...props} className="list-disc ml-10" ordered="false"></li>
        ),
      }}
    />
  );
}

export default Richtext;
